import type { ComponentProps } from 'react';

import { FormContextConsumer } from '#/components/Form/FormContext';

import { AddressFormContainerInternal } from './AddressFormContainerInternal';

type AddressFieldsContainerProps = Omit<
  ComponentProps<typeof AddressFormContainerInternal>,
  | 'address'
  | 'clearErrors'
  | 'error'
  | 'errors'
  | 'fetchingAddress'
  | 'setFetchingAddress'
  | 'updateAddress'
>;

export function AddressFieldsContainer({
  index,
  ...restProps
}: AddressFieldsContainerProps) {
  const addressKey = index !== undefined ? `addresses.${index}` : 'address';
  return (
    <FormContextConsumer>
      {({
        clearErrors,
        updateValueWith,
        fetchingAddress,
        setFetchingAddress,
        errors,
        getValue,
      }) => (
        <AddressFormContainerInternal
          index={index}
          // @ts-expect-error TS(2322): Type 'unknown' is not assignable to type 'Address ... Remove this comment to see the full error message
          address={getValue(addressKey)}
          fetchingAddress={fetchingAddress}
          setFetchingAddress={setFetchingAddress}
          updateAddress={(update) => {
            updateValueWith(addressKey, (a) => ({ ...a, ...update }));
          }}
          clearErrors={clearErrors}
          error={errors[addressKey]}
          errors={errors}
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...restProps}
        />
      )}
    </FormContextConsumer>
  );
}
